export default "__VITE_ASSET__BI0_sYA2__"